import { useGetListDevicesBySnQuery } from '../redux/devicesApi';
import {
  getDeviceSnsFromSubs,
  getProductIdsFromSubsWithUpcomingPlan,
} from '../utils/helpers';
import { useGetListSubscriptionsQuery } from '../redux/subscriptionsApi';
import {
  isSubException,
  mergeSubsAndDevices,
  mergeSubsAndProducts,
  sortSubscriptions,
} from '../utils/subscriptions';
import { useGetProductsQuery } from '../redux/productsApi';

const useGetSubscriptions = () => {
  const {
    data: fullSubscriptionsData,
    isLoading: loadingSubscriptions,
    refetch: subRefetch,
  } = useGetListSubscriptionsQuery();
  // remove exceptions
  const subscriptionsData = {
    ...fullSubscriptionsData,
    subscriptions: fullSubscriptionsData?.subscriptions?.filter(
      (sub) => !isSubException(sub),
    ),
  };
  const devicesSns = getDeviceSnsFromSubs(subscriptionsData);
  const {
    data: devicesData,
    isLoading: loadingDeviceData,
    refetch: deviceRefetch,
  } = useGetListDevicesBySnQuery(devicesSns, {
    skip: !devicesSns?.length > 0,
  });
  const mergedSubscriptionsAndDevices = mergeSubsAndDevices(
    subscriptionsData,
    devicesData,
  );

  const productIds = getProductIdsFromSubsWithUpcomingPlan(
    mergedSubscriptionsAndDevices,
  );
  const { data: productsData } = useGetProductsQuery(
    {
      external_product_ids: productIds,
      format_version: '2022-06',
    },
    { skip: !productIds.length },
  );

  const mergedSubscriptions = mergeSubsAndProducts(
    mergedSubscriptionsAndDevices,
    productsData,
  );

  const subscriptions = sortSubscriptions(mergedSubscriptions);

  const subscriptionsLoading = loadingSubscriptions || loadingDeviceData;

  const refetchSubs = () => {
    subRefetch();
    deviceRefetch();
  };
  return [subscriptions, subscriptionsLoading, refetchSubs];
};

export default useGetSubscriptions;
